import {
  AgentCriteria,
  PageRequest,
  PaginationResponseType,
  ResponseType,
  AgentType,
} from '@/types';
import { axios, get, post, put } from './baseAxios';
import { API_AGENT } from './urls';

const url = API_AGENT;

const create = (request: AgentType): Promise<ResponseType<AgentType>> => post(`${url}`, request);

const update = (id: number, request: AgentType): Promise<ResponseType<AgentType>> =>
  put(`${url}/${id}`, request);

const deleteById = (id: number): Promise<ResponseType<boolean>> => axios.delete(`${url}/${id}`);

const getById = (id: number): Promise<ResponseType<AgentType>> => get(`${url}/${id}`);

const filter = (
  request: PageRequest & AgentCriteria
): Promise<PaginationResponseType<AgentType[]>> => get(`${url}`, { params: { ...request } });

const publish = (request: AgentType): Promise<ResponseType<AgentType>> =>
  put(`${url}/${request.id}/published`, request);

export { create, deleteById, filter, getById, publish, update };
